import React from 'react'
import ReactDOM from 'react-dom'
import App from './container/App'
import ThemeProvider from './styles/themeProvider'
import { store } from './store'
import { Provider } from 'react-redux'
import { setupAxiosInterceptors } from './utils/axiosSetup'

setupAxiosInterceptors()

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider>
        <App />
      </ThemeProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
)
